/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ClientStatus {
    DISABLED = 'Disabled',
    ENABLED = 'Enabled',
    SOFT_DELETED = 'SoftDeleted',
}
